<template>
  <div class="rooms" v-if="roomsBrief.length">
    <PhotoWall :imgUrls="photos" :autoDisplay="true" coverLetter=":Rooms"></PhotoWall>
    <article>
      <h1>
        Enjoy your stay
        <br />
        <span class="subTitle">perfect place for holiday</span>
      </h1>
      <div class="rooms-list">
        <briefCard
          v-for="(brief, i) in roomsBrief"
          :key="i"
          :id="brief.id"
          :name="brief.name"
          :normalDayPrice="brief.normalDayPrice"
          :holidayPrice="brief.holidayPrice"
          :imageUrl="brief.imageUrl"
        ></briefCard>
      </div>
    </article>
  </div>
</template>

<script>
import { mapState } from "vuex";
import briefCard from "@/components/briefCard.vue";
import PhotoWall from "@/components/PhotoWall.vue";
export default {
  created() {
    if (this.$store.state.roomsBrief.length < 1) {
      this.$store.dispatch("getAllRoomsInfo");
    }
  },
  components: {
    briefCard,
    PhotoWall
  },
  computed: {
    ...mapState(["roomsBrief"]),
    photos() {
      const ar = [];
      this.roomsBrief.forEach(el => {
        ar.push(el.imageUrl);
      });
      return ar;
    }
  }
};
</script>

<style lang="scss" scoped>
.rooms-list {
  display: flex;
  flex-flow: row wrap;
  margin: 0 calc(-1 * var(--g-s));
}
h1 {
  line-height: 0.8em;
}
.subTitle {
  font-size: var(--fs-s);
  color: var(--text-color-lightest);
}
</style>
